import { DistributionReportStat, IndividualRecipientReportApiModel, distributionReportRelevantStatHierarchy } from './distribution-report-stat-api.model';
import { EmailEventInterface } from './email-event.interface';

export class EmailRecipientModel {
    email: string;
    status: DistributionReportStat;
    stats: DistributionReportStat[];
    events: EmailEventInterface[];
    mailingListId?: number;

    constructor(api: IndividualRecipientReportApiModel, mailingListId?: number) {
        this.email = api.email;
        this.stats = Object.keys(api.stats) as DistributionReportStat[];
        this.events = api.events;
        this.mailingListId = mailingListId;

        this.status = distributionReportRelevantStatHierarchy.find(relevantStat =>
            this.stats.find(eventType => eventType === relevantStat)
        );
    }
}
